import { motion } from 'framer-motion';
import React from 'react';
import styled from 'styled-components';

export const WorkPin = ({ className, variants }) => (
  <WorkPinSVG
    width="513"
    height="787"
    viewBox="0 0 513 787"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    variants={variants}
  >
    <g filter="url(#a)">
      <ellipse
        cx="256"
        cy="663.5"
        rx="179"
        ry="49.5"
        fill="#000"
        fillOpacity=".2"
      />
    </g>
    <g filter="url(#b)">
      <path
        d="M4 36C4 16.118 20.118 0 40 0h433c19.882 0 36 16.118 36 36v491.107c0 19.882-16.118 35.999-36 35.999H344.701c-1.83 0-3.56.836-4.699 2.269l-90.326 113.713-76.695-113.344a6.002 6.002 0 0 0-4.97-2.638H40c-19.882 0-36-16.117-36-36V36Z"
        fill="#FF6696"
      />
      <path
        d="M40 4h433c17.673 0 32 14.327 32 32v491.107c0 17.673-14.327 32-32 32H344.701a9.999 9.999 0 0 0-7.831 3.78l-86.936 109.445-73.641-108.83a9.998 9.998 0 0 0-8.282-4.395H40c-17.673 0-32-14.327-32-32V36C8 18.327 22.327 4 40 4Z"
        stroke="#fff"
        strokeWidth="8"
      />
    </g>
    <path
      d="M103.44 437.892c-3.766 0-7.142-.611-10.126-1.834-2.984-1.223-5.38-3.033-7.19-5.43-1.761-2.397-2.691-5.283-2.789-8.658H96.69c.195 1.908.856 3.375 1.98 4.402 1.126.979 2.593 1.468 4.403 1.468 1.859 0 3.327-.416 4.403-1.248 1.076-.88 1.614-2.079 1.614-3.595 0-1.272-.44-2.324-1.321-3.155-.831-.832-1.883-1.517-3.155-2.055-1.223-.538-2.984-1.149-5.283-1.834-3.326-1.027-6.041-2.055-8.145-3.082-2.103-1.027-3.913-2.544-5.43-4.549-1.516-2.006-2.274-4.623-2.274-7.851 0-4.794 1.737-8.537 5.21-11.227 3.473-2.739 7.998-4.109 13.574-4.109 5.675 0 10.248 1.37 13.722 4.109 3.473 2.69 5.332 6.457 5.576 11.3H107.99c-.098-1.663-.71-2.96-1.835-3.889-1.125-.978-2.568-1.468-4.329-1.468-1.516 0-2.74.416-3.669 1.248-.93.783-1.394 1.932-1.394 3.449 0 1.663.783 2.959 2.348 3.888 1.565.93 4.011 1.933 7.338 3.009 3.326 1.125 6.017 2.201 8.071 3.228 2.103 1.028 3.913 2.52 5.43 4.476 1.516 1.957 2.275 4.476 2.275 7.558 0 2.935-.759 5.601-2.275 7.998-1.468 2.397-3.62 4.305-6.457 5.723-2.837 1.419-6.188 2.128-10.053 2.128ZM182.19 395.995c5.087 0 9.123 1.541 12.107 4.622 3.033 3.082 4.549 7.362 4.549 12.841v23.921h-12.474v-22.233c0-2.642-.709-4.672-2.127-6.09-1.37-1.468-3.278-2.202-5.724-2.202s-4.378.734-5.797 2.202c-1.369 1.418-2.054 3.448-2.054 6.09v22.233h-12.474v-22.233c0-2.642-.709-4.672-2.128-6.09-1.37-1.468-3.277-2.202-5.723-2.202-2.446 0-4.378.734-5.797 2.202-1.37 1.418-2.054 3.448-2.054 6.09v22.233h-12.548v-40.944h12.548v5.136c1.271-1.712 2.935-3.057 4.989-4.035 2.055-1.028 4.378-1.541 6.971-1.541 3.082 0 5.821.66 8.218 1.981 2.446 1.321 4.354 3.204 5.723 5.65 1.419-2.25 3.351-4.085 5.797-5.503 2.446-1.419 5.112-2.128 7.998-2.128ZM205.127 416.833c0-4.206.783-7.9 2.348-11.079 1.614-3.18 3.791-5.626 6.53-7.338 2.74-1.712 5.797-2.568 9.172-2.568 2.887 0 5.406.587 7.558 1.761 2.201 1.174 3.889 2.715 5.063 4.623v-5.797h12.547v40.944h-12.547v-5.797c-1.223 1.908-2.935 3.449-5.136 4.623-2.153 1.174-4.672 1.761-7.558 1.761-3.326 0-6.359-.856-9.099-2.568-2.739-1.761-4.916-4.232-6.53-7.411-1.565-3.229-2.348-6.947-2.348-11.154Zm30.671.074c0-3.131-.88-5.601-2.641-7.411-1.713-1.81-3.816-2.715-6.311-2.715s-4.623.905-6.384 2.715c-1.712 1.761-2.568 4.207-2.568 7.337 0 3.131.856 5.626 2.568 7.485 1.761 1.81 3.889 2.715 6.384 2.715 2.495 0 4.598-.905 6.311-2.715 1.761-1.81 2.641-4.281 2.641-7.411Zm1.468-32.359c0 2.69-.881 4.843-2.642 6.457-1.712 1.614-3.84 2.421-6.384 2.421-2.543 0-4.671-.807-6.383-2.421-1.712-1.614-2.569-3.767-2.569-6.457 0-2.691.857-4.843 2.569-6.457 1.712-1.614 3.84-2.422 6.383-2.422 2.544 0 4.672.808 6.384 2.422 1.761 1.614 2.642 3.766 2.642 6.457Zm-5.504 0c0-1.076-.342-1.932-1.027-2.568-.636-.685-1.467-1.027-2.495-1.027-.978 0-1.81.342-2.494 1.027-.636.636-.954 1.492-.954 2.568 0 1.027.318 1.883.954 2.568.684.685 1.516 1.027 2.494 1.027 1.028 0 1.859-.342 2.495-1.027.685-.685 1.027-1.541 1.027-2.568ZM263.66 392.179c-2.202 0-4.011-.636-5.43-1.908-1.37-1.32-2.055-2.935-2.055-4.843 0-1.956.685-3.571 2.055-4.842 1.419-1.321 3.228-1.982 5.43-1.982 2.152 0 3.913.661 5.283 1.982 1.418 1.271 2.128 2.886 2.128 4.842 0 1.908-.71 3.523-2.128 4.843-1.37 1.272-3.131 1.908-5.283 1.908Zm6.31 50.483c0 5.038-1.272 8.658-3.815 10.859-2.544 2.251-6.091 3.376-10.64 3.376h-4.916v-10.64h3.008c1.37 0 2.348-.269 2.935-.807.587-.538.881-1.419.881-2.641v-46.374h12.547v46.227ZM297.629 437.966c-4.011 0-7.631-.856-10.86-2.568-3.179-1.713-5.699-4.158-7.558-7.338-1.809-3.18-2.714-6.897-2.714-11.153 0-4.207.929-7.9 2.788-11.08 1.859-3.229 4.402-5.699 7.631-7.411 3.229-1.712 6.848-2.568 10.86-2.568 4.011 0 7.631.856 10.859 2.568 3.229 1.712 5.773 4.182 7.631 7.411 1.859 3.18 2.789 6.873 2.789 11.08s-.954 7.924-2.862 11.153c-1.859 3.18-4.427 5.625-7.704 7.338-3.229 1.712-6.849 2.568-10.86 2.568Zm0-10.86c2.397 0 4.427-.88 6.09-2.641 1.712-1.762 2.568-4.281 2.568-7.558 0-3.278-.831-5.797-2.495-7.558-1.614-1.761-3.619-2.641-6.016-2.641-2.446 0-4.476.88-6.091 2.641-1.614 1.712-2.421 4.231-2.421 7.558 0 3.277.783 5.796 2.348 7.558 1.614 1.761 3.62 2.641 6.017 2.641ZM338.259 402.232c1.174-1.908 2.861-3.449 5.063-4.623 2.201-1.174 4.72-1.761 7.557-1.761 3.376 0 6.433.856 9.172 2.568 2.74 1.712 4.892 4.158 6.457 7.338 1.615 3.179 2.422 6.873 2.422 11.079 0 4.207-.807 7.925-2.422 11.154-1.565 3.179-3.717 5.65-6.457 7.411-2.739 1.712-5.796 2.568-9.172 2.568-2.886 0-5.405-.563-7.557-1.688-2.153-1.174-3.84-2.715-5.063-4.623v5.724h-12.548V383.08h12.548v19.152Zm17.903 14.601c0-3.13-.88-5.576-2.641-7.337-1.712-1.81-3.84-2.715-6.384-2.715-2.495 0-4.623.905-6.384 2.715-1.712 1.81-2.568 4.28-2.568 7.411 0 3.13.856 5.601 2.568 7.411 1.761 1.81 3.889 2.715 6.384 2.715 2.495 0 4.623-.905 6.384-2.715 1.761-1.859 2.641-4.354 2.641-7.485ZM388.06 402.232c1.174-1.908 2.861-3.449 5.063-4.623 2.201-1.174 4.72-1.761 7.557-1.761 3.376 0 6.433.856 9.172 2.568 2.74 1.712 4.892 4.158 6.458 7.338 1.614 3.179 2.421 6.873 2.421 11.079 0 4.207-.807 7.925-2.421 11.154-1.566 3.179-3.718 5.65-6.458 7.411-2.739 1.712-5.796 2.568-9.172 2.568-2.886 0-5.405-.563-7.557-1.688-2.153-1.174-3.84-2.715-5.063-4.623v5.724h-12.548V383.08h12.548v19.152Zm17.903 14.601c0-3.13-.88-5.576-2.641-7.337-1.712-1.81-3.84-2.715-6.384-2.715-2.495 0-4.622.905-6.383 2.715-1.713 1.81-2.569 4.28-2.569 7.411 0 3.13.856 5.601 2.569 7.411 1.761 1.81 3.888 2.715 6.383 2.715s4.623-.905 6.384-2.715c1.761-1.859 2.641-4.354 2.641-7.485Z"
      fill="#fff"
    />
    <g filter="url(#c)">
      <path
        d="m260.118 134.925 26.825 40.024v-53.65l-26.825 13.626Z"
        fill="#84CDB5"
      />
      <path d="M324.841 90.641h-25.122v32.786h25.122V90.641Z" fill="#fff" />
      <path
        d="M302.273 90.641h-83.882l-30.231 30.657 28.102 22.993-.851 21.29h40.024l-5.109-21.29 49.818-20.864 2.129-32.786Z"
        fill="#4274B9"
      />
      <path
        d="m315.898 295.023-10.645-78.346-40.45-11.496-9.794-39.599H215.41l-5.961 129.441h106.449Z"
        fill="#fff"
      />
      <path
        d="m292.904 227.322-66.85 4.258-2.554 49.392h76.643l-7.239-53.65Z"
        fill="#84CDB5"
      />
    </g>
    <defs>
      <filter
        id="a"
        x="3"
        y="540"
        width="506"
        height="247"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="37" result="effect1_foregroundBlur" />
      </filter>
      <filter
        id="b"
        x="0"
        y="0"
        width="513"
        height="687.088"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
      </filter>
      <filter
        id="c"
        x="164.16"
        y="70.641"
        width="184.681"
        height="252.382"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="12" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
      </filter>
    </defs>
  </WorkPinSVG>
);

export const WorkPinSVG = styled(motion.svg)`
  z-index: 120;
`;
